import useSWR from "swr";
import { SplatCheckoutStepsResponse } from "../../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { getWithAuth } from "utils/dataUtils";

type CheckoutTask = {
  urlSlug?: string;
  label: string;
  taskViewTitle?: string;
  icon: string;
  id: string;
  isComplete: boolean;
  isUnlocked: boolean;
  isInProgress: boolean;
  order: number;
  shouldHideHeaderOnLoading: boolean;
};

const useCheckoutStepsData = (
  prospectId: string,
  proposalId: string,
  authKey: string,
  proposalToken?: string
) => {
  const CHECKOUT_STEPS_URL = `/prospect/${prospectId}/checkoutSteps?proposalId=${proposalId}`;
  const shouldFetch = Boolean(prospectId && proposalId);

  const { data, error, isLoading, mutate, isValidating } = useSWR(
    shouldFetch &&
      (authKey
        ? ["Get Checkout Steps", CHECKOUT_STEPS_URL, authKey]
        : [
            "Customer Get Checkout Steps",
            `/customer${CHECKOUT_STEPS_URL}`,
            proposalToken,
          ]),
    getWithAuth<SplatCheckoutStepsResponse>,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
    }
  );

  return {
    steps: data?.steps,
    opportunityId: data?.opportunityId,
    completeCheckout: data?.completeCheckout ?? false,
    stepsError: error,
    isStepsLoading: isLoading || isValidating,
    isRefetchingSteps: isValidating,
    canSignInPerson: data?.signInPerson,
    isHqsRequired: data?.isHqsRequired,
    splatRole: data?.splatRole,
    userProfile: data?.userProfile,
    refetch: mutate,
  } as const;
};

export { useCheckoutStepsData };
export type { CheckoutTask };
